import React, { FC } from "react";
import styles from "../../../styles/B2C/SearchInput.module.scss";
import { SearchIcon } from "../../../utils/b2cIcons";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  // When true, the search box stays pinned at the top of the scroll area
  // (used on long, scrollable steps like City / Nearest Office).
  sticky?: boolean;
}

const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  sticky = false,
}) => {
  return (
    <div
      className={`${styles.searchWrapper} ${sticky ? styles.sticky : ""}`}
    >
      <SearchIcon className={styles.searchIcon} />
      <input
        type="text"
        className={styles.searchInput}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SearchInput;
